<template>
  <v-card class="mx-auto mb-6 mr-0" outlined width="360">
    <v-row class="d-flex justify-content-between pa-4">
      <v-col md="8" sm="8">
        <span class="form__label primary--text mb-3" style="font-size: 12px">
          {{ this.card.tipo_conformidade.nome }}
        </span>
      </v-col>
      <v-col md="4" sm="4">
        <v-avatar v-bind:class="colorStatus" size="10" />
        <span class="form__label grey--text mb-2" style="font-size: 10px">
          {{ this.card.status.nome }}
        </span>
      </v-col>
    </v-row>
    <v-row class="pa-6 pt-0 pb-0">
      <v-divider />
    </v-row>
    <v-row v-if="this.card.file.length <= 0">
      <v-col class="pa-4">
        <DropFile
          class="pa-2"
          @selected-files="addFile"
          :multiple="false"
          style="font-size: 11px;"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pa-4">
        <DocumentDataTable
          v-if="card.file.length > 0"
          class="doc-card"
          :documents="card.file"
          @preview-file="onPreviewFile"
          @remove-file="onRemoveFile(card)"
          :disabled="agreementApproved"
        />
      </v-col>
    </v-row>
    <ModalDeleteLineTable v-model="showDeleteModal" @close="closeModal" />
    <v-row
      v-if="
        (userIsEmployee && !agreementApproved) ||
          (!userIsEmployee && agreementReproved)
      "
    >
      <v-col class="pa-4 pb-0">
        <BaseFormTextArea
          v-if="this.card.file.length > 0"
          id-element="agreementJustify"
          placeholder=""
          v-model="card.justificativa"
          :rules="[maxLengthTextArea]"
          label-text="Justificativa"
          :readonly="!isEmployeeUser"
          :disabled="agreementReproved"
          style="font-size: 10px;"
        />
      </v-col>
    </v-row>
    <v-row
      v-if="isEmployeeUser && this.card.file.length > 0 && !agreementApproved"
    >
      <v-col class="pa-4 pt-0">
        <BaseButton
          color="error"
          width="75px"
          style="font-size: 14px"
          class="base-input-file__button mr-2 px-0"
          @click="repprove()"
        >
          Reprovar
        </BaseButton>
        <BaseButton
          color="secondary"
          class="base-input-file__button px-0"
          width="75px"
          style="font-size: 14px"
          @click="approve()"
        >
          Aprovar
        </BaseButton>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import DocumentDataTable from "../../../components/DocumentDataTable.vue";
import DropFile from "../../../components/DropFile.vue";
import { FILE, documentAlreadyUploaded } from "@/mixins/DocumentsMixin";
import DocumentsMixin from "@/mixins/DocumentsMixin";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import { requiredInput, maxLengthTextArea } from "@/utils/rules.js";
import ModalDeleteLineTable from "../components_agro/ModalDeleteLineTable.vue";
import { mapState, mapActions } from "vuex";
import _ from "lodash";

const DEFAULT_STATUS = [
  {
    id: "pendente",
    nome: "Pendente"
  },
  {
    id: "em_analise",
    nome: "Em Análise"
  },
  {
    id: "negado",
    nome: "Negado"
  },
  {
    id: "aprovado",
    nome: "Aprovado"
  }
];

export default {
  name: "QuotationAgreementCard",
  mixins: [DocumentsMixin, LoadingRequest],
  created() {
    this.checkStatusFile();
  },
  data: () => ({
    status: DEFAULT_STATUS,
    requiredInput,
    maxLengthTextArea,
    selectedFile: null,
    interval: null,
    showDeleteModal: false,
    shouldDeleteData: false
  }),
  components: {
    DropFile,
    DocumentDataTable,
    ModalDeleteLineTable
  },
  computed: {
    ...mapState("me", ["userIsEmployee", "myInfo"]),
    isEmployeeUser() {
      return this.userIsEmployee;
    },
    colorStatus() {
      switch (this.card.status.id) {
        case "pendente":
          return "yellow";
        case "em_analise":
          return "blue";
        case "negado":
          return "error";
        case "aprovado":
          return "success";
        default:
          return "yellow";
      }
    },
    agreementApproved() {
      let isApproved = this.card.status.id == "aprovado";
      return isApproved;
    },
    agreementReproved() {
      let isReproved = this.card.status.id == "negado";
      return isReproved;
    }
  },
  methods: {
    ...mapActions("quotation", [
      "requestUploadAgroAgreement",
      "requestUploadCafezalAgreement",
      "requestCardAgroAgreement",
      "requestApproveUploadAgroAgreement",
      "requestRejectUploadAgroAgreement"
    ]),
    ...mapActions(["showAlertNotification"]),
    closeModal(valor) {
      this.shouldDeleteData = valor;
      this.showDeleteModal = false;
      this.$emit("modal-closed");
    },
    async addFile(arquivo) {
      this.selectedFile = this.card.file.concat(
        arquivo.map(file => ({
          arquivo: {
            [FILE]: file,
            nome: file.name
          }
        }))
      );
      this.card.file = await this.submitFiles();
      this.card.status = this.status.find(x => x.id == "em_analise");
      this.card.justificativa = "";

      if (this.product == "agricola") {
        await this.withLoading(
          this.requestUploadAgroAgreement(this.getPayload())
        );
      } else {
        await this.withLoading(
          this.requestUploadCafezalAgreement(this.getPayload())
        );
      }
    },
    getPayload() {
      let payload = {
        id: this.card.id,
        cotacao_custo_agro_id: this.card.custo_agro_id,
        cotacao_custo_cafezal_id: this.card.custo_cafezal_id,
        arquivo_link: this.card.file[0].url,
        arquivo_nome: this.card.file[0].nome,
        status: {
          id: this.card.status.id,
          name: this.card.status.nome
        },
        tipo_conformidade: {
          id: this.card.tipo_conformidade.id,
          name: this.card.tipo_conformidade.nome
        },
        justificativa: this.card.justificativa
      };
      return payload;
    },
    async checkStatusFile() {
      try {
        this.requestCardAgroAgreement(this.card.id).then(response => {
          this.card.status = {
            id: response.status.id,
            nome: response.status.name
          };
          if (this.card.file.length > 0 && response.status.id == "pendente") {
            this.card.file = [];
          }
          if (response.justificativa != "") {
            this.card.justificativa = response.justificativa;
          }
        });
      } catch (error) {
        console.error("Erro ao consultar o status do arquivo:", error);
      }
    },
    async onRemoveFile(card) {
      this.showDeleteModal = true;
      const handleModalClosed = async () => {
        if (this.shouldDeleteData) {
          let payload = {
            id: card.id,
            cotacao_custo_agro_id: card?.custo_agro_id,
            cotacao_custo_cafezal_id: card?.custo_cafezal_id,
            arquivo_link: null,
            arquivo_nome: null,
            status: {
              id: "pendente",
              name: "Pendente"
            },
            tipo_conformidade: {
              id: card.tipo_conformidade.id,
              name: card.tipo_conformidade.nome
            },
            justificativa: null
          };

          if (this.product == "agricola") {
            await this.withLoading(this.requestUploadAgroAgreement(payload));
          } else {
            await this.withLoading(this.requestUploadCafezalAgreement(payload));
          }
          await this.checkStatusFile();
        }
      };
      this.$once("modal-closed", handleModalClosed);
    },
    async submitFiles() {
      const { uploadDocument } = this;
      return Promise.all(
        _.map(this.selectedFile, document =>
          documentAlreadyUploaded(document)
            ? Promise.resolve(document)
            : uploadDocument(document.arquivo[FILE], (file, arquivo) => arquivo)
        )
      );
    },
    async approve() {
      this.card.justificativa = "";
      this.withLoading(
        await this.requestApproveUploadAgroAgreement(
          this.getPayload()
        ).then(() => this.checkStatusFile())
      );
    },
    async repprove() {
      if (_.isEmpty(this.card.justificativa)) {
        this.showAlertNotification({
          message: "É necessário especificar o motivo da recusa.",
          type: "error"
        });
        return;
      }
      this.withLoading(
        await this.requestRejectUploadAgroAgreement(
          this.getPayload()
        ).then(() => this.checkStatusFile())
      );
    }
  },
  props: {
    card: {
      type: Object
    },
    product: {
      type: String
    }
  },
  watch: {
    "card.status"(newValue) {
      if (newValue.id != "em_analise") {
        clearInterval(this.interval);
        return;
      }
      if (this.interval == null) {
        this.interval = setInterval(() => {
          this.checkStatusFile();
        }, 10000);
      }
    }
  }
};
</script>
<style lang="sass">
.base-input-file__button.button-size.doc-card
  height: 32px !important
.img-size
  width: 20px !important
.icon-size
  width: 16px
.base__datatable.v-data-table.theme--light.doc-card
  padding: 4px
  padding-top: 0
  table
    border-spacing: 0px !important
  thead tr th
    font-weight: 600
    font-size: 10px
    padding: 8px 16px
  tbody tr td
    padding: 14px 12px
    font-size: 10px
    font-weight: 700
</style>
